import * as React from 'react';
import {
  Paper,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  FormControl,
  CircularProgress,
  Checkbox,
  responsiveFontSizes
} from '@mui/material';
import api from "../../services/api";
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import { pt } from 'yup-locale-pt';

import { useStoreState, useStoreActions } from 'easy-peasy';
import { Autocomplete, TextField} from '../../components';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

yup.setLocale(pt);


const DialogoAutorizaTemasUsuarios = ({ open, onClose, roles, usuario }) => {

  let loading = useStoreState((state) => state.nav.loading);
  let startLoading = useStoreActions((actions) => actions.nav.startLoading);
  let stopLoading = useStoreActions((actions) => actions.nav.stopLoading);
  let user = useStoreState((state) => state.auth.user);
  const [temas,setTemas] = React.useState([]);

  const role = roles.filter((role)=>{
    return role.id != 'admin';
  });


  const schema = yup.object({
    temas: yup.array()
      .of(yup.string())
      .label('Temas')
      .required(),
    email: yup.string().email()
      .nullable()
      .label('Email')
      .required(),
    roleId:yup.string()
      .nullable()
      .oneOf(roles.map((role)=>role.id))
      .label('Tipo de perfil')
      .required(),
  }).required();

  const useFormRef = useForm({
    mode: 'onTouched',
    resolver: yupResolver(schema)
  });

  const { handleSubmit,reset,watch,setValue,
          formState: {isDirty,isSubmitting}
        } = useFormRef;

  const roleId = watch('roleId');
  const selectedTemas = watch('temas');

  React.useEffect(()=>{
    if(roleId=='gestor') {
      setValue('temas',temas
               .map(tema=>tema.id));
    } else {
      if(selectedTemas)
        setValue('temas',
                 selectedTemas.filter((tema)=>tema != '08'));
    }
    if(roleId =='preenchedorSso'){
      setValue('temas', temas
               .filter(tema=>['00a','03a','03b'].includes(tema.id))
               .map(tema=>tema.id));
    }
  },[roleId]);

  const onSave = async (data) => {
    startLoading();
    try{
      if(data.id)
        await api.http.put('/users/'+data.id,data);
      else
        await api.http.post('/users',data);
      stopLoading({ severity: 'success' });
      close(true);
    }catch (error) {
      stopLoading({
        message: error.toString(),
        severity: 'error'
      });
      throw error;
    };
  };

  const loadTemas = async (mount) => {
    startLoading();
    try {
      let data = (await api.http.get('/temas')).data;
      if(mount.isMounted)
      setTemas(data);
      stopLoading();
    } catch(error) {
      stopLoading({
        message: error.toString(),
        severity: 'error'
      });
      throw error;
    }
  };

  React.useEffect(()=>{
    let mount = {
       isMounted: true
     };
    loadTemas(mount);
    return () => {
      mount.isMounted = false;
    };
  },[]);

  const close = (reload=false) => {
    reset({
      temas: [],
      email:'',
      roleId:''
    });
    onClose(reload);
  };

  React.useEffect(()=> {
    reset(usuario);
  },[usuario]);

  return (
    <Dialog open={open} onClose={()=>close()}>
      <DialogTitle>Autorizar Usuário</DialogTitle>
      <DialogContent sx={{'width':600,'height':350}}>
        <FormControl sx={{ my: 2 }} fullWidth>
          <TextField field="email" type="email"
                     schema={schema} useFormRef={useFormRef} />
        </FormControl>
        <FormControl sx={{ my: 2 }} fullWidth>
          <Autocomplete
            field="roleId"
            useFormRef={useFormRef}
            options={role}
            getOptionLabel={(ind) => ind.name}
            schema={schema} />
        </FormControl>
        <FormControl sx={{ my: 2 }} fullWidth>
          <Autocomplete
            multiple
            disableCloseOnSelect
            field="temas"
            useFormRef={useFormRef}
            options={temas}
            getOptionLabel={(tema) => tema.id+' - '+tema.name}
            renderOption={(props, option, { selected }) => {
              const {key, ...restProps} = props;
              return (
                <li key={key} {...restProps}>
                  <Checkbox
                    icon={icon}
                    checkedIcon={checkedIcon}
                    style={{ marginRight: 8 }}
                    checked={selected}
                  />
                  {props.key}
                </li>
              );
            }}
            schema={schema}
            readOnly={roleId=='gestor' || roleId == 'preenchedorSso'}
          />
        </FormControl>
      </DialogContent>
      <DialogActions>
        { loading>0 &&
          <CircularProgress
            size={30}
            sx={{'position': 'absolute', 'left':25, 'bottom': 12}} /> }
        <Button color="inherit" onClick={()=>close()}>
          CANCELAR
        </Button>
        <Button color="primary"
                onClick={handleSubmit(onSave)}
                disabled={!isDirty || isSubmitting}>
          SALVAR
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogoAutorizaTemasUsuarios;
